/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div>
    <div class="item-position project-alarmStat title-item">
      <div class="first"></div>
      <div class="two">01</div>
      <div class="title">
        <div>Alarm Statistics</div>
        <div>报警统计</div>
      </div>
    </div>
    <div class="item-position alarm-common alarmStat-day">
      <div>今日</div>
      <div id="alarmStat-day"/>
    </div>
    <div class="item-position alarm-common alarmStat-week">
      <div>本周</div>
      <div id="alarmStat-week"/>
    </div>
    <div class="item-position alarm-common alarmStat-month">
      <div>本月</div>
      <div id="alarmStat-month"/>
    </div>
  </div>
</template>

<script>
import G2 from '@antv/g2'
export default {
  name: 'TicketStatChart',
  data () {
    return {
      dayChart: null,
      weekChart: null,
      monthChart: null
    }
  },
  props: {
    day: {
      type: Array
    },
    week: {
      type: Array
    },
    month: {
      type: Array
    }
  },
  watch: {
    day (val, oldVal) {
      if (val !== oldVal) {
        this.dayChart.source(val)
        this.dayChart.repaint()
      }
    },
    week (val, oldVal) {
      if (val !== oldVal) {
        this.weekChart.source(val)
        this.weekChart.repaint()
      }
    },
    month (val, oldVal) {
      if (val !== oldVal) {
        this.monthChart.source(val)
        this.monthChart.repaint()
      }
    }
  },
  methods: {
    initDayChart () {
      this.dayChart = new G2.Chart({
        container: 'alarmStat-day',
        width: 300,
        height: 150,
        padding: [ 10, 20, 20, 20 ]
      })
      this.dayChart.legend(false)
      this.dayChart.axis('value', {
        grid: null
      })
      this.dayChart.tooltip({
        'g2-tooltip': {
          border: '1px solid rgb(73, 213, 243)',
          backgroundColor: ' rgba(0, 0, 0, 0.1)',
          color: 'rgb(255, 255, 255)',
          boxShadow: 'rgb(73, 213, 243) 0px 0px 3px'
        }
      })
      this.dayChart.intervalStack()
        .position('type*value')
        .color('name')
        .tooltip('name*value', (name, value) => {
          return {
            name: name,
            value: value + '次'
          }
        })
      this.dayChart.axis('type', {
        line: {
          stroke: '#545454'
        },
        tickLine: {
          stroke: '#545454'
        }
      })
      this.dayChart.tooltip({
        useHtml: true,
        position: 'top',
        containerTpl: '<div class="g2-tooltip">' +
          '<div class="g2-tooltip-title" style="margin-bottom: 4px;"></div>' +
          '<div class="g2-tooltip-list" style="display: flex;width:300px;flex-flow: wrap;"></div>' +
          '</div>',
        itemTpl: '<div data-index={index}>' +
          '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right: 4px"></span>' +
          '{name}<span style="margin: 0 20px 0 10px;color:{color}">{value}</span>' +
          '</div>'
      })
      this.dayChart.render()
    },
    initWeekChart () {
      this.weekChart = new G2.Chart({
        container: 'alarmStat-week',
        width: 300,
        height: 150,
        padding: [ 10, 20, 20, 30 ]
      })
      this.weekChart.legend(false)
      this.weekChart.axis('value', {
        grid: null
      })
      this.weekChart.tooltip({
        'g2-tooltip': {
          border: '1px solid rgb(73, 213, 243)',
          backgroundColor: ' rgba(0, 0, 0, 0.1)',
          color: 'rgb(255, 255, 255)',
          boxShadow: 'rgb(73, 213, 243) 0px 0px 3px'
        }
      })
      this.weekChart.intervalStack()
        .position('type*value')
        .color('name')
        .tooltip('name*value', (name, value) => {
          return {
            name: name,
            value: value + '次'
          }
        })
      this.weekChart.axis('type', {
        line: {
          stroke: '#545454'
        },
        tickLine: {
          stroke: '#545454'
        }
      })
      this.weekChart.tooltip({
        useHtml: true,
        position: 'top',
        containerTpl: '<div class="g2-tooltip">' +
          '<div class="g2-tooltip-title" style="margin-bottom: 4px;"></div>' +
          '<div class="g2-tooltip-list" style="display: flex;width:300px;flex-flow: wrap;"></div>' +
          '</div>',
        itemTpl: '<div data-index={index}>' +
          '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right: 4px"></span>' +
          '{name}<span style="margin: 0 20px 0 10px;color:{color};">{value}</span>' +
          '</div>'
      })
      this.weekChart.render()
    },
    initMonthChart () {
      this.monthChart = new G2.Chart({
        container: 'alarmStat-month',
        width: 300,
        height: 150,
        padding: [ 10, 20, 20, 20 ]
      })
      this.monthChart.legend(false)
      this.monthChart.axis('value', {
        grid: null
      })
      this.monthChart.tooltip({
        'g2-tooltip': {
          border: '1px solid rgb(73, 213, 243)',
          backgroundColor: ' rgba(0, 0, 0, 0.8)',
          color: 'rgb(255, 255, 255)',
          boxShadow: 'rgb(73, 213, 243) 0px 0px 3px'
        }
      })
      this.monthChart.intervalStack()
        .position('type*value')
        .color('name')
        .tooltip('name*value', (name, value) => {
          return {
            name: name,
            value: value + '次'
          }
        })
      this.monthChart.axis('type', {
        line: {
          stroke: '#545454'
        },
        tickLine: {
          stroke: '#545454'
        }
      })
      this.monthChart.tooltip({
        useHtml: true,
        position: 'top',
        containerTpl: '<div class="g2-tooltip">' +
          '<div class="g2-tooltip-title" style="margin-bottom: 4px;"></div>' +
          '<div class="g2-tooltip-list" style="display: flex;width:300px;flex-flow: wrap;"></div>' +
          '</div>',
        itemTpl: '<div data-index={index}>' +
          '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right: 4px"></span>' +
          '{name}<span style="margin: 0 20px 0 10px;color:{color};">{value}</span>' +
          '</div>'
      })
      this.monthChart.render()
    }
  },
  mounted () {
    this.initDayChart()
    this.initWeekChart()
    this.initMonthChart()
  }
}
</script>

<style scoped lang="scss">
  .project-alarmStat{
    left:10px;
    top:130px;
  }
  .alarm-common {
    display: flex;
    align-items: center;
    div:first-child{
      width: 20px;
      color: #abacad;
      font-size: 12px;
    }
  }
  .alarmStat-day {
    left: 10px;
    top: 169px;
  }
  .alarmStat-week {
    left: 10px;
    top: 329px
  }
  .alarmStat-month {
    left: 10px;
    top: 489px
  }
</style>



// WEBPACK FOOTER //
// src/components/TicketStatChart.vue